import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getlinksRequest, updateTonality } from "../../../api/LinksApi";
import CoreLayout from "../../../layouts/core-layout";
import ResultsLayout from "./results-layout";
import { useTranslation } from "react-i18next";
import { useCart } from "react-use-cart";
import SentimentBadgeHelpers from "../../../helpers/SentimentBadgeHelpers";
import LoadingResults from "./elements/LoadingResults";
import IsMeBadgeHelpers from "../../../helpers/IsMeBadgeHelpers";
import { useMutation, useQuery, useQueryClient } from "react-query";
import ButtonAdd from "../components/ButtonAdd";
import ButtonRemove from "../components/ButtonRemove";
import VeilleCardComponent from "../components/VeilleDateComponent";
import {
  getDiagnosisByGroupUuid,
  getDiagnosisByUIIDRequest,
} from "../../../api/DiagnosisApi";
import { ModalConfirm, PriceDisplay, WarningQuotas } from "../../../lib/product-manager/ProductManager";
import { ProductActionHandler } from "../../../lib/product-action-handler/ProductActionHandler";
import { getProductActions, ProductActionStatus } from "../../../api/ProductManagerActionApi";
import { BankManagerAccounContext } from "../../../lib/bank-manager/BankManagerAccount";
import { getPackageOrProduct } from "../../../lib/product-manager/product-manager.service";
import { AttributeGroup, PackageAttribute, Product, ProductAttribute } from "../../../lib/product-manager/types";
import i18n from "../../../i18n";
import { ProductAttributeGroupManager } from "../../../lib/product-manager/product-attribute-group";

export default function LinksResults() {

  const [refreshCount, setRefreshCount] = useState<number>(0)
  const [allDiagsVeille, setAllDiagsVeille] = useState<any[]>([]);
  const [originalDiag, setOriginalDiag] = useState<any>({});
  const [originalMonth, setOriginalMonth] = useState<any>();
  const { t } = useTranslation(); // Multi Language
  const { diagUUID } = useParams();
  const { data, isLoading } = useQuery(["links", refreshCount], () =>
    getlinksRequest(diagUUID)
  );

  const [linksto, setLinks] = useState<any>(data);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(updateTonality);
  const onSubmitTonality = async (values: any) => {
    await mutateAsync(values);
    queryClient.invalidateQueries("links");
  };

  useEffect(() => {
    getDiagnosisByUIIDRequest(diagUUID).then(function (res: any) {
      setOriginalMonth(new Date(res?.data.data.createdAt).getMonth());
      setOriginalDiag(res?.data.data);
    });
    getDiagnosisByGroupUuid(diagUUID)
      .then(function (res: any) {
        setAllDiagsVeille(res?.data.data);
      })
      .catch((err) => console.log("veilleDateComponent", err));
  }, [diagUUID, refreshCount]);

  function getActionMetadata() {
    return {}
  }

  const { account, refresh: refreshAccount } = useContext(BankManagerAccounContext)
  const [pendingAction, setPendingAction] = useState<{
    checkoutId: number;
    pendingActionCount: number;
  } | null
  >(null)

  function handleIsActionPending(params: {
    checkoutId: number;
    pendingActionCount: number;
  }) {
    setPendingAction(params)
  }

  const [product, setProduct] = useState<(Product | null)>(null)
  const [selectedOptions, setSelectedOptions] = useState<{ groupId: number, id: number }[]>([])
  const [modalConfirmToggled, setModalConfirmToggled] = useState<boolean>(false)

  useEffect(() => {
    getPackageOrProduct('google-serp', 'Product').then((data) => data.results[0])
      .then((product: Product) => {
        setProduct(product)
        setSelectedOptions(
          product.attributeGroups.reduce((array, attributeGroup) => {
            array = [...array, ...attributeGroup.attributes.filter((attribute) => attribute.isDefault).map((attribute) => ({
              ...attribute,
              group: { id: attributeGroup.id } as AttributeGroup<PackageAttribute | ProductAttribute>
            }))]
            return array
          }, [] as ProductAttribute[])
            .map((attribute: ProductAttribute) => ({
              groupId: attribute?.group?.id as unknown as number,
              id: attribute.id as unknown as number
            }))
        )
      }
      )
  }, [refreshCount])

  if (isLoading) {
    return (
      <CoreLayout template="main">
        <ResultsLayout
          description={t("core:pages.osculteo.results.section.suggest.text")}
        >
          <div className="text-center mt-20 mb-20">
            <LoadingResults />
          </div>
        </ResultsLayout>
      </CoreLayout>
    );
  }

  if (data?.length === 0) {
    return (
      <CoreLayout template="main">
        <ResultsLayout
          description={t("core:pages.osculteo.results.section.suggest.text")}
        >

          <ProductActionHandler
            pendingActionCount={pendingAction?.pendingActionCount}
            checkoutId={pendingAction?.checkoutId}
            getActions={
              (checkoutId: number) =>
                getProductActions({ status: [ProductActionStatus.SUCCESS], checkoutId }).then((response) => {
                  return response.data.data.results
                })
            }
            onTargetedActionExists={(targetedActions) => {
              refreshAccount()
              setPendingAction(null)
              setRefreshCount((state) => state + 1)
              setModalConfirmToggled(false)
            }}
          >

            <div className="form w-lg-500px mx-auto py-20">

              {product?.prices?.[0]?.value ? <div className="mb-10 d-flex align-items-center justify-content-end">
                <PriceDisplay
                  currentLanguage={i18n.language || 'fr'}
                  value={product?.prices?.[0]?.value || 0}
                  creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                />
              </div>
                : null}

              <div className="text-center mb-10">
                <h1 className="text-dark mb-3">
                  {t("core:pages.osculteo.results.DiagnosisWithNegativeKeyword.title")}
                </h1>
              </div>
              <div className="mb-10">
                {t("core:pages.osculteo.results.DiagnosisWithNegativeKeyword.text")}

              </div>


              <div className="fv-row mb-10">
                {product && product.attributeGroups.length ?
                  <ProductAttributeGroupManager
                    currentLanguage={i18n.language || 'fr'}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    groups={product.attributeGroups}
                    creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
                  /> : null

                }
              </div>

              <div className="text-center mt-4">
                <button
                  className={`btn btn-lg ${!product || !product.isAvailable ? 'btn-secondary' : 'btn-primary'} w-100 mb-5`}
                  disabled={!product || !product.isAvailable}
                  onClick={() => setModalConfirmToggled(true)}
                >
                  {t(
                    "core:pages.osculteo.results.googleNews.action"
                  )}

                </button>
              </div>

              {!product?.isAvailable ? <WarningQuotas products={[product as Product]} currentLanguage={i18n.language || 'fr'} /> : null}

            </div>


            <ModalConfirm
              diagUUID={diagUUID}
              creditSystemEnabled={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === '1'}
              loadingImageBaneerSrc={`${process.env.REACT_APP_CDN_PLATFORMS}/slider-1.jpg`}
              currentLanguage={i18n.language as 'fr' | 'en'}
              userBalance={process.env.REACT_APP_CREDIT_SYSTEM_ENABLED === "1" ? account?.balance || 0 : null}
              getActionMetadata={getActionMetadata}
              isActionPending={pendingAction ? true : false}
              setIsActionPending={handleIsActionPending}
              selectedItems={product && selectedOptions ? [
                { ...product, selectedProductAttributesIds: selectedOptions.map((selectedOption) => selectedOption.id) }
              ] : []}
              setShow={setModalConfirmToggled}
              show={modalConfirmToggled}
            />

          </ProductActionHandler>
        </ResultsLayout>
      </CoreLayout>
    );
  }

  return (
    <>
      <CoreLayout template="main">
        <ResultsLayout
          description={t("core:pages.osculteo.results.section.link.text")}
        >
          <br />

          {allDiagsVeille.length > 1 && (
            <VeilleCardComponent
              allDiagsVeille={allDiagsVeille}
              original={originalDiag}
              originalMonth={originalMonth}
              setLinks={setLinks}
            />
          )}
          {linksto === undefined
            ? data?.map((item: any) => (
              <div>
                <ResultRow item={item} />
              </div>
            ))
            : linksto?.map((item: any) => (
              <div key={item.id}>
                <ResultRow key={item.id} item={item} changeTonality={onSubmitTonality} />
              </div>
            ))}
        </ResultsLayout>
      </CoreLayout>
    </>
  );
}

/**
 * ResultRow
 *
 * @param {*} props
 * @return {*}
 */
const ResultRow = (props: any) => {

  const { t } = useTranslation()
  const item = props.item;
  const { diagUUID } = useParams();
  const { inCart } = useCart();
  const alreadyAdded = inCart(item.id);

  return (
    <>
      <div className="row mt-10">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-1" style={{ fontSize: "38px" }}>
                  <div className="text-center">
                    <b>{item.position}</b>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="text-center mt-5">
                    <div className="miniTexte">Sentiment</div>
                    <SentimentBadgeHelpers uuid={item.uuid} tonality={item.tonality} type={"link"} />
                    <div className="miniTexte greymini">
                      {t(
                        "core:pages.osculteo.results.sentiments.clickToChange"
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="text-center mt-5">
                    <div className="miniTexte"> {t(
                      "core:pages.osculteo.results.sentiments.isMe.label"
                    )}</div>
                    <IsMeBadgeHelpers me={item.itSMe} uuid={item.uuid} />
                    <div className="miniTexte greymini">
                      {t(
                        "core:pages.osculteo.results.sentiments.clickToChange"
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-5">
                  <div>
                    <b>
                      <img
                        alt="img"
                        src={
                          "https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=" +
                          item.url +
                          "&size=16"
                        }
                      />
                      &nbsp;&nbsp;
                      <span className="resultsRowTitle">{item.title}</span>
                    </b>
                  </div>
                  <div>{item.description}</div>
                  <a href={item.url} target="blank" className="text-primary">
                    {item.url}
                  </a>
                </div>

                <div className="col-md-2">
                  <div className="text-end mt-10">
                    {alreadyAdded ? (
                      <ButtonRemove itemId={item.id} />
                    ) : (
                      <ButtonAdd item={item} diag={diagUUID} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
